require('../../../assets/lib/angularjs-slider-2.11.0/rzslider.min.js');
require('../../../assets/lib/js/jv.ModalWidget.webpack.js');
require('../../../assets/scripts/candidates/details/jv.friendWidgetMin.js');
require('../../../assets/lib/fileuploader/fileuploader.js');
require('../../../assets/scripts/source/person/JV.AngularUtils.js');
require('../../../assets/same-origin/lib/tinymce_6.7.0/tinymce.min.js');
require('../../../assets/same-origin/lib/tinymce_4.6.4/jquery.tinymce.min.js');
require('../../../assets/scripts/common/jv.MeetingRoomSelect.js');
require('../../../assets/scripts/candidates/jv.candidate.details.app.dummy.js');
require('../../../assets/scripts/jhire/services/jv.AppModel.js');
require('../../../assets/lib/underscore/underscore-min.js');
require('../../../assets/lib/jquery/timepicker/jquery.timepicker.js');
require('../../../assets/stylekit/js/jv.Calendar.js');
require('../../../assets/scripts/candidates/details/workflow/jv.advancedScheduler.calendar.factory.webpack.js');
require('../../../assets/lib/jquery/jquery.xml2json.js');
require('../../../assets/lib/xml2json.js');
require('../../../assets/lib/ng-infinite-scroll/ngInfiniteScroll.min.js');
require('../../../assets/lib/multidatepicker/multidatepicker.js');
require('../../../assets/lib/onboarding/mask/jquery.mask-1.14.16.js');
require('../../../assets/scripts/candidates/jv.candidate.details.app.js');